import React from 'react'
import { LEVEL } from './utils/constants/levels'
import { STATUS } from './utils/constants/statuses'
import { formatDisplayDate } from './utils/displayUtils'
import LevelProgressPopover from './LevelProgressPopover'
import SuspensionWarningBar from './SuspensionWarningBar'
import { useMembershipJourneyContext } from './MembershipJourneyContext'
import {
  LevelProgressBar as StyledLevelProgressBar,
  LevelProgressContent,
  LevelProgressText,
  LevelProgressCount,
  DateInfo,
  DateLabel,
  DateValue,
  DateDivider
} from './Styles/ProgressTracker.styles'

const LEVEL_NAMES = {
  [LEVEL.QUALIFYING]: 'Qualifying',
  [LEVEL.LEVEL_1]: 'Level 1',
  [LEVEL.LEVEL_2]: 'Level 2',
  [LEVEL.LEVEL_3]: 'Level 3'
}

const LevelProgressBar = ({ activeLevel }) => {
  const { pgmProgress } = useMembershipJourneyContext()
  
  const isSuspended = pgmProgress?.isSuspended

  // If suspended, show suspension warning bar across all levels
  if (isSuspended) {
    return <SuspensionWarningBar />
  }

  if (activeLevel === LEVEL.QUALIFYING) {
    return null
  }
  
  const levelName = LEVEL_NAMES[activeLevel] || 'Level'
  
  const activeLevelData = pgmProgress?.levels?.find(l => l.key === activeLevel)
  
  if (!activeLevelData) {
    return null
  }
  
  const isCompleted = activeLevelData.status === STATUS.COMPLETE
  const { startDate, completionDate, expirationDate } = activeLevelData
  
  // For in-progress levels, show expiration date; for completed levels, show completion date
  const displayDate = isCompleted ? completionDate : expirationDate
  
  if (!displayDate) {
    return null
  }
  
  const formattedStartDate = formatDisplayDate(startDate)
  const formattedEndDate = formatDisplayDate(displayDate)
  
  return (
    <StyledLevelProgressBar>
      <LevelProgressContent>
        {isCompleted ? (
          <>
            <DateInfo>
              <DateLabel>{levelName} Started: </DateLabel>
              <DateValue>{formattedStartDate}</DateValue>
            </DateInfo>
            <DateDivider />
            <DateInfo>
              <DateLabel>{levelName} Completed: </DateLabel>
              <DateValue>{formattedEndDate}</DateValue>
            </DateInfo>
          </>
        ) : (
          <LevelProgressText>
            {levelName} Completion Deadline: {' '}
            <LevelProgressCount>{formattedEndDate}</LevelProgressCount>
          </LevelProgressText>
        )}
      </LevelProgressContent>
      <LevelProgressPopover />
    </StyledLevelProgressBar>
  )
}

export default LevelProgressBar

